export const patchTextObject = (textObj) => {
    if (!textObj || (textObj.type !== 'textbox' && textObj.type !== 'i-text')) return;

    const originalInitDimensions = textObj.initDimensions;
    textObj.initDimensions = function () {
        const ctx = this.canvas?.contextContainer;
        if (ctx) {
            ctx.font = this._getFontDeclaration();
            ctx.fillText(`Font Preload ${this.fontFamily}`, 0, 0);
        }
        return originalInitDimensions.call(this);
    };

    if (textObj.canvas) {
        textObj.canvas.renderAll();
    }
};